var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconRightPanelOpener(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "ic-side-menu-right-24px",
    xmlns: "http://www.w3.org/2000/svg",
    width: 500,
    height: 500,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_84",
    "data-name": "Rectangle 84",
    width: 40,
    height: 40,
    rx: 4,
    fill: "none"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Component_45_7",
    "data-name": "Component 45 \\u2013 7",
    transform: "translate(8 8)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_85 ",
    "data-name": "Rectangle 85",
    width: 24,
    height: 24,
    rx: 4,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Union_9 ",
    "data-name": "Union 9",
    d: "M-18747-11793v-16h6a2,2,0,0,1,2,2v12a2,2,0,0,1-2,2Zm6-2v-12h-4v12Zm-8.006,2H-18761a2,2,0,0,1-2-2v-12a2,2,0,0,1,2-2h12v2h-12v12h12v2Z",
    transform: "translate(18763 11813.002)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconRightPanelOpener);
export default __webpack_public_path__ + "static/media/icon-right-panel-opener.04d7074563e62e3f646a5bfaf7fe6867.svg";
export { ForwardRef as ReactComponent };